module.exports = __webpack_public_path__ + "static/img/12.ee75548.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/12.jpeg
// module id = 1nec
// module chunks = 0